import { Box, Link, Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { DataGridComponent } from "../common/DataGridComponent";
import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid-pro";
import { AppState, useAppDispatch, useAppSelector } from "../../store";
import AddIcon from "@mui/icons-material/Add";
import { useVendors } from "../../hooks/useVendors";
import {
  setIsEditVendor,
  setOpenAddVendorDialog,
  setOpenDeleteVendor,
  setVendorDetails,
} from "../../store/slices/vendorSlice";
import VendorDetails from "./VendorDetails";
import VendorDialog from "./VendorDialog";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteVendorDialog from "./DeleteVendorDialog";
import { datagridUtils } from "../../utils/datagridUtils";
import { useParams } from "react-router-dom";
const VendorsList: React.FunctionComponent<any> = (props) => {
  const {
    vendorsList,
    paginationModel,
    setPaginationModel,
    allVendorsIsLoading,
    rowsCount,
    filterVal,
    setFilterVal,
    getAllVendorsFunc,
    sortModel,
    handleSortModelChange,
    codelistData,
  } = props;
  const dispatch = useAppDispatch();
  const params = useParams();
  const openAddVendorDialog = useAppSelector(
    (state: AppState) => state.vendorSlice.openAddVendorDialog
  );
  const openDelete = useAppSelector(
    (state: AppState) => state.vendorSlice.openDeleteVendor
  );
  const { getVendorDetails } = useVendors();
  const [openVendorDetails, setOpenVendorDetails] = useState(false);
  const onClickVendor = async (data: any) => {
    const response = await getVendorDetails({
      study_id: params?.study_id,
      vendor_id: data?.vendor_id,
    });
    if (response?.data) {
      dispatch(setVendorDetails(response?.data));
      setOpenVendorDetails(true);
    }
  };
  const onClickAddVendor = () => {
    dispatch(setOpenAddVendorDialog(true));
  };
  const onEditClick = async (data: any) => {
    const response = await getVendorDetails({
      study_id: params?.study_id,
      vendor_id: data?.vendor_id,
    });
    if (response?.data) {
      dispatch(setVendorDetails(response?.data));
      dispatch(setOpenAddVendorDialog(true));
      dispatch(setIsEditVendor(true));
    }
  };
  const onDeleteClick = (data: any) => {
    dispatch(setVendorDetails(data));
    dispatch(setOpenDeleteVendor(true));
  };

  const countryOptions = datagridUtils(codelistData, "CNTRY")?.valueOptions;

  const columns: GridColDef[] = [
    {
      field: "vendor_id",
      headerName: "Vendor ID",
      minWidth: 100,
      flex: 1,
      renderCell: (params: any) => (
        <>
          <Link onClick={() => onClickVendor(params?.row)}>
            {params.row.vendor_id}
          </Link>
        </>
      ),
    },
    {
      field: "vendor_name",
      headerName: "Vendor Name",
      flex: 1,
    },
    {
      field: "city",
      headerName: "City",
      flex: 1,
    },
    {
      field: "state",
      headerName: "State",
      flex: 1,
    },
    {
      field: "country_value_code",
      headerName: "Country",
      flex: 1,
      type: "singleSelect",
      valueOptions: countryOptions,
      renderCell: (params: any) =>
        countryOptions?.find(
          (e: any) => e.value == params?.row?.country_value_code
        )?.label,
    },
    {
      field: "actions",
      width: 90,
      align: "center",
      type: "actions",
      headerName: "Actions",
      sortable: false,
      getActions: (params) => [
        <GridActionsCellItem
          key={params.row.id}
          icon={<EditIcon />}
          label="Edit"
          onClick={() => onEditClick(params.row)}
          showInMenu
        />,
        <GridActionsCellItem
          key={params.row.id}
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => onDeleteClick(params.row)}
          showInMenu
        />,
      ],
    },
  ];

  return (
    <>
      {openVendorDetails ? (
        <VendorDetails
          setOpenVendorDetails={setOpenVendorDetails}
          getAllVendorsFunc={getAllVendorsFunc}
          paginationModel={paginationModel}
          filterVal={filterVal}
          codelistData={codelistData}
        />
      ) : (
        <>
          <Grid container spacing={2} mb={2}>
            <Grid item xs>
              <Typography variant="h5">Vendor List</Typography>
            </Grid>
            <Grid item justifyContent="flex-end">
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                onClick={onClickAddVendor}
                id="add_new_vendor"
                aria-label="Click to Add New Vendor details"
              >
                Add New
              </Button>
            </Grid>
          </Grid>
          <Box sx={{ width: "100%", height: "calc(100vh - 304px)" }}>
            <DataGridComponent
              columns={columns}
              rows={vendorsList}
              paginationMode="server"
              showQuickFilter
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              loading={allVendorsIsLoading}
              rowsCount={rowsCount}
              filterMode="server"
              filterValues={(data: any) => setFilterVal(data)}
              disableRowSelectionOnClick
              sortingMode="server"
              sortModel={sortModel}
              onSortModelChange={handleSortModelChange}
              checkboxSelection
              exportFileName="Vendor_List"
            />
          </Box>
        </>
      )}
      {openAddVendorDialog && (
        <VendorDialog
          getAllVendorsFunc={getAllVendorsFunc}
          paginationModel={paginationModel}
          filterVal={filterVal}
          codelistData={codelistData}
        />
      )}
      {openDelete && (
        <DeleteVendorDialog
          getAllVendorsFunc={getAllVendorsFunc}
          paginationModel={paginationModel}
          filterVal={filterVal}
          setOpenVendorDetails={setOpenVendorDetails}
        />
      )}
    </>
  );
};

export default VendorsList;
